(async () => {
  if (!customElements.get("image-carousel")) {
    const { default: Swiper, Scrollbar, Mousewheel } = await import("swiper");

    Swiper.use([Scrollbar, Mousewheel]);

    class ImageCarousel extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector(".swiper");
        this.swiperOptions = {
          slidesPerView: "auto",
          spaceBetween: 16,
          freeMode: true,
          threshold: 10,
          mousewheel: true,
          watchSlidesProgress: true,
          scrollbar: {
            el: `.swiper-scrollbar-${this.dataset.sectionId}`,
            draggable: true,
          },
        };

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperElement) {
          // Update the swiper
          window.addEventListener("shopify:section:load", () => {
            this.swiperElement.update();
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener("shopify:block:select", (event) => {
            this.swiperElement.update();
            this.handleBlockSelect(event);
          });

          // When on block deselect go to the slide in front-end
          window.addEventListener("shopify:block:deselect", (event) => {
            this.swiperElement.update();
            this.handleBlockSelect(event);
          });
        }
        this.init();
      }

      init() {
        this.swiperElement = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleBlockSelect(event) {
        // Check if we have slides
        if (!this.swiperElement || !this.swiperElement.slides) return;

        // Find the slide index
        const selectedSlide = Array.from(this.swiperElement.slides).findIndex(
          (slide) => slide === event.target || slide.contains(event.target)
        );

        if (selectedSlide === -1) return;
        this.swiperElement.slideTo(selectedSlide, 1000);
      }
    }
    window.ImageCarousel = ImageCarousel;
    customElements.define("image-carousel", ImageCarousel);
  }
})();
